export default "__VITE_ASSET__Chnk3qiP__"